// extracted by mini-css-extract-plugin
module.exports = {"label":"Overview_label_1KO2T","value":"Overview_value_100mi"};